
import { ApiResponse, apiCall } from "./apiClient";
import { FlespiAPIResponse, FlespiDeviceCommandResponse, FlespiStartVideoStreamCommandResponse, FlespiVehicleCameraData, FlespiVideoTimelineData } from "../models/vehicle/flespiDataTypes";

export const startVideoStream = (
    flespiDeviceId: string,
    channelIdx: number,
    signal?: AbortSignal): Promise<ApiResponse<FlespiAPIResponse<FlespiDeviceCommandResponse<FlespiStartVideoStreamCommandResponse>>>> => {
    return apiCall<FlespiAPIResponse<FlespiDeviceCommandResponse<FlespiStartVideoStreamCommandResponse>>, null>(
        `vehiclemedia/${flespiDeviceId}/startStream/${channelIdx}`,
        "GET", null, signal);
};

export const stopVideoStream = (
    flespiDeviceId: string,
    channelIdx: number,
    signal?: AbortSignal): Promise<ApiResponse<FlespiAPIResponse<FlespiDeviceCommandResponse<string>>>> => {
    return apiCall<FlespiAPIResponse<FlespiDeviceCommandResponse<string>>, null>(
        `vehiclemedia/${flespiDeviceId}/stopStream/${channelIdx}`,
        "GET", null, signal);
};

export const startPlaybackStream = (
    flespiDeviceId: string,
    channelIdx: number,
    from: Date,
    durationInSeconds : number,
    signal?: AbortSignal): Promise<ApiResponse<FlespiAPIResponse<FlespiDeviceCommandResponse<FlespiStartVideoStreamCommandResponse>>>> => {
    return apiCall<FlespiAPIResponse<FlespiDeviceCommandResponse<FlespiStartVideoStreamCommandResponse>>, null>(
        `vehiclemedia/${flespiDeviceId}/playback/${channelIdx}?from=${from.toISOString()}&durationInSeconds=${durationInSeconds}`,
        "GET", null, signal);
};

export const loadVideoTimeLineForDate = (
    flespiDeviceId: string,
    channelIdx: number,
    date : Date): Promise<ApiResponse<FlespiAPIResponse<FlespiVideoTimelineData>>> => {

    const endTime = new Date(date);
    endTime.setDate(endTime.getDate() + 1);

    return loadVideoTimeLine(
        flespiDeviceId,
        channelIdx,
        date,
        endTime);
};

export const loadVideoTimeLine = (
    flespiDeviceId: string,
    channelIdx: number,
    from: Date,
    to: Date,
    signal?: AbortSignal): Promise<ApiResponse<FlespiAPIResponse<FlespiVideoTimelineData>>> => {
    return apiCall<FlespiAPIResponse<FlespiVideoTimelineData>, null>(
        `vehiclemedia/${flespiDeviceId}/timeline/${channelIdx}?from=${from.toISOString()}&to=${to.toISOString()}`,
        "GET", null, signal);
};

export const loadVehicleCameras = (
    signal?: AbortSignal): Promise<ApiResponse<FlespiVehicleCameraData[]>> => {
    return apiCall<FlespiVehicleCameraData[], null>(
        "vehiclemedia/allVehicleCameras",
        "GET", null, signal);
};
